import { Router, Route, Switch, } from 'react-router-dom';
import { createBrowserHistory } from "history";
import DocIndex from './pages/doc/Index';
import CertIndex from './pages/doc/cert/Index';
import ScrapIndex from './pages/doc/scrap/Index';
import CompletionIndex from './pages/doc/completion/Index';

import Error404 from './pages/error/Error404';
import Error500 from './pages/error/Error500';

const history = createBrowserHistory();
const Routing = () =>{

    return (
        <Router history={history}>
            <Switch>
                <Route exact path={"/"} component={(props) => <DocIndex {...props} />}/> {/** [CM5000-1]사업자번호 입력 */}
                <Route exact path={"/doc/cert"} component={(props) => <CertIndex {...props} />}/> {/** [CM5000-4]공동인증서 등록 안내 */}
                <Route exact path={"/doc/scrap"} component={(props) => <ScrapIndex {...props} />}/> {/** [CM5000-5]서류 제출 리스트 */}
                <Route exact path={"/doc/completion"} component={(props) => <CompletionIndex {...props} />}/> {/** [CM5000-6]서류 제출 완료 */}
                <Route path={"/404"} component={(props) => <Error404 {...props} />}/> {/* NotFound */}
                <Route path={"/500"} component={(props) => <Error500 {...props} />}/> {/* ServerError */}
                <Route path={"/*"} component={(props) => <Error404 {...props} />}/> {/* NotFound */}
            </Switch>
        </Router>
    )
};
export default Routing;